import {useQuery} from '@apollo/react-hooks';

import {makeDataDangerous, safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetInboxThreadCounts as GetInboxThreadCountsQuery,
    GetInboxThreadCountsVariables as GetInboxThreadCountsQueryVariables,
} from 'nutshell-graphql-types';

import GET_THREAD_COUNTS from '../queries/get-inbox-thread-counts.graphql';

const POLL_INTERVAL_MILLISECONDS = 5000; // 5 seconds

export const useGetInboxThreadCounts = (
    input: {
        assignees: string[];
    },
    skipPolling?: boolean
) => {
    const {data, error, loading, refetch, networkStatus} = useQuery<
        GetInboxThreadCountsQuery,
        GetInboxThreadCountsQueryVariables
    >(GET_THREAD_COUNTS, {
        variables: {...input},
        fetchPolicy: 'cache-and-network',
        pollInterval: skipPolling ? undefined : POLL_INTERVAL_MILLISECONDS,
    });

    const {inboxThreadCounts} = makeDataDangerous(data);

    const isLoading = loading && networkStatus === 1 && !inboxThreadCounts;

    return {
        inboxThreadCounts,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
        refetch,
    };
};
